import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import styled from 'styled-components';
const PLUS_ICON_SIZE = 32;

export const TitleContainer = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
});

export const PlusButton = styled.button<{
  isExpanded: boolean;
}>`
  width: ${PLUS_ICON_SIZE}px;
  height: ${PLUS_ICON_SIZE}px;
  margin-left: ${({ theme }) => theme.spacing[10]};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;
  border: none;

  > svg {
    margin: auto;
    flex-shrink: 0;
    transition: 0.4s;
  }

  ${({ isExpanded }) =>
    isExpanded &&
    `
    > svg {
      transform: rotate(-45deg);
    }
  `}
  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    :hover {
      > svg path {
        fill: ${({ theme }) => theme.colors.darkOrangeHover};
      }
    }
  }
`;

export const ParcelListTitle = styled(Typography).attrs({
  variant: TextStyles['Heading 1'],
  className: 'section-title',
})<{
  isExpanded: boolean;
}>(({ theme, isExpanded }) => ({
  color: theme.colors.highEmphasisBlack,
  position: 'relative',
  wordBreak: 'break-word',

  ':after': {
    content: '""',
    display: 'block',
    width: 24,
    height: 3,
    background: theme.colors.darkOrange,
  },

  marginBottom: isExpanded ? theme.spacing[20] : 0,
}));

export const TrackingWidgetWrapper = styled.div({});
